import { render, staticRenderFns } from "./_base-card.vue?vue&type=template&id=5529bbe4&scoped=true&"
import script from "./_base-card.vue?vue&type=script&lang=js&"
export * from "./_base-card.vue?vue&type=script&lang=js&"
import style0 from "./_base-card.vue?vue&type=style&index=0&id=5529bbe4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529bbe4",
  null
  
)

export default component.exports